export class StatisticsCollector {
  constructor(data) {
    this.url = data.url;
    this.startTime = data.startTime;
    this.emitter = data.emitter;
    this.qformIds = data.qformIds || {};
    this.statistics = {};
  }
  async loadModule() {
    this.Transporter = await import('./transporter').then(data => {
      return data.transporter;
    });
  }
  async init() {
    await this.loadModule();
    this.subscribeStatEvents();
  }
  setTimesTampForm(data) {
    //для видеовиджета в данных меняем значение ключа идентификатора
    if (data.id.match(/^videowidget/)) {
      this.statistics[data.id].videowidgetId = data.id;
    } else {
      this.statistics[data.id].qformId = data.id;
    }
    this.statistics[data.id].timestamp = (this.startTime / 1000).toFixed();
  }
  setSiteId(data) {
    this.statistics[data.id].siteId = data.site_id;
  }
  setUidForm(data) {
    this.statistics[data.id].uid = data.uid;
  }
  setBuildTimeForm(data) {
    this.statistics[data.id].buildTime = data.id.match(/^videowidget/) ? String(data.time) : data.time;
  }
  setFullTimeForm(data) {
    this.statistics[data.id].fullTime = data.id.match(/^videowidget/) ? String(data.time - this.startTime) : data.time - this.startTime;
  }

  /* 
  Пример объекта со статистикой для формы, отправляемый на сервер
  {
    "qformId": "dsadsadas",
    "timestamp": 1578324233,
    "fullTime": 1500,
    "buildTime": 5
  } 
  */

  /* 
  Пример объекта со статистикой для виджета, отправляемый на сервер
  {
    "videowidgetId": "dsadsadas",
    "timestamp": 1578324233,
    "fullTime": 1500,
    "buildTime": 5
  } 
  */

  // подписка на старт и конец формирования формы
  subscribeStatEvents() {
    this.qformIds.forEach(id => {
      this.statistics[id] = {};
      this.emitter.subscribe(`${id}:timesTamp`, this.setTimesTampForm.bind(this));
      this.emitter.subscribe(`${id}:uid`, this.setUidForm.bind(this));
      this.emitter.subscribe(`${id}:siteId`, this.setSiteId.bind(this));
      this.emitter.subscribe(`${id}:buildTime`, this.setBuildTimeForm.bind(this));
      this.emitter.subscribe(`${id}:fullTime`, this.setFullTimeForm.bind(this));
      this.emitter.subscribe(`${id}:requestStatistic`, this.pushStatistic.bind(this));
    });
  }
  pushStatistic(_ref) {
    let {
      id
    } = _ref;
    this.Transporter.post(`https://${this.url}`, {
      body: this.statistics[id],
      options: {
        method: "POST",
        decode: false
      }
    });
  }
}